/* eslint-disable class-methods-use-this, @typescript-eslint/no-unused-vars */
import Cookies from 'js-cookie';
import type { CookieAttributes, CookiesStatic } from 'js-cookie';

export default class CookieStateStore implements Storage {
  private store: CookiesStatic<string>;

  private readonly cookiesOptions: CookieAttributes;

  constructor() {
    const domain: string = window.location.host.split('.').slice(-2).join('.');
    this.cookiesOptions = {
      domain,
      secure: true,
      sameSite: 'lax' as const,
      expires: new Date(Date.now() + 10 * 60 * 1000), // 10 minutes
    };

    this.store = Cookies.withAttributes(this.cookiesOptions);
  }

  getItem(key: string): string | null {
    return this.store.get(key) || null;
  }

  setItem(key: string, value: string): void {
    this.store.set(key, value);
  }

  removeItem(key: string): void {
    this.store.remove(key);
  }

  clear(): void {
    // Unimplemented
  }

  key(index: number): string | null {
    return null;
  }

  get length(): number {
    return 0;
  }
}
